import { Action } from '@ngrx/store';
import { TrackingProductList } from '@app/shared/components/catalog/catalog.component';
import { CatalogPage, ContentsMarketingFilter, Deal } from '@vestiaire/api-sdk-angular';
import { ICatalogState } from '@app/+catalog/store/model/catalog-state.model';

export const CATALOG_PAGE_SEARCH = '[Catalog] on catalog page search';
export const CATALOG_PAGE_LOAD = '[Catalog] on catalog page init';
export const TRACK_MERCH_BLOCK = '[Catalog] on catalog page loaded from merch block';
export const SET_CATALOG_PAGE_NUMBER = '[Catalog] set catalog page state';
export const SET_CATALOG_NB_PAGES = '[Catalog] set catalog page count';
export const SET_CATALOG_NB_PRODUCTS = '[Catalog] set catalog product count';
export const CREATE_ALERT_SUCCESS = '[Catalog] Alert created';
export const APPLY_FILTER = '[Catalog] Click on filter';
export const TRACK_PRODUCT_CLICK = '[Catalog] Click on a product after search';
export const TRACK_PRODUCT_CROSS_SELL_CLICK = '[Catalog] Click on a product related to another one';
export const TRACK_PRODUCT_FEED_CLICK = '[Catalog] Click on a product that came from home or a PLP on the CMS';
export const TRACK_SEO_LINK_CLICK = '[Catalog] Click on a seo link';
export const SET_MARKETING_FILTER = '[Catalog] Set Marketing Filter';
export const SET_DEAL = '[Catalog] Set the current Deal to active or not, update name and colors';

export class OnCatalogPageSearch implements Action {
  readonly type = CATALOG_PAGE_SEARCH;

  constructor(public payload: TrackingProductList) {}
}

export class OnCatalogPageLoad implements Action {
  readonly type = CATALOG_PAGE_LOAD;

  constructor(public payload: CatalogPage) {}
}

export class TrackMerchBlock implements Action {
  readonly type = TRACK_MERCH_BLOCK;
  constructor(public payload: { cmsBlockId: string; isMerchBlock: boolean }) {}
}

export class SetCatalogPageNumber implements Action {
  readonly type = SET_CATALOG_PAGE_NUMBER;
  constructor(public payload: ICatalogState) {}
}

export class SetCatalogNbPages implements Action {
  readonly type = SET_CATALOG_NB_PAGES;
  constructor(public payload: ICatalogState) {}
}

export class SetCatalogNbProducts implements Action {
  readonly type = SET_CATALOG_NB_PRODUCTS;
  constructor(public payload: ICatalogState) {}
}
export class CreateAlertSuccess implements Action {
  readonly type = CREATE_ALERT_SUCCESS;
  constructor(public payload) {}
}
export class ApplyFilter implements Action {
  readonly type = APPLY_FILTER;
  constructor(public payload) {}
}
export class TrackProductClick implements Action {
  readonly type = TRACK_PRODUCT_CLICK;
  constructor(public payload) {}
}

export class TrackSeoLinksClick implements Action {
  readonly type = TRACK_SEO_LINK_CLICK;
  constructor(public payload) {}
}

export class TrackProductCrossSellClick implements Action {
  readonly type = TRACK_PRODUCT_CROSS_SELL_CLICK;
  constructor(public payload: { productPosition: number; productId: string }) {}
}

export class TrackProductFeedClick implements Action {
  readonly type = TRACK_PRODUCT_FEED_CLICK;
  constructor(
    public payload: {
      blockSubCategory: string;
      position: number;
      indexName: string;
      productId: string;
      page_type: string;
    }
  ) {}
}

export class SetMarketingFilter implements Action {
  readonly type = SET_MARKETING_FILTER;
  constructor(public payload: ContentsMarketingFilter[]) {}
}
export class SetDeal implements Action {
  readonly type = SET_DEAL;
  constructor(public payload: Deal) {}
}

export type CatalogActions =
  | OnCatalogPageLoad
  | OnCatalogPageSearch
  | SetCatalogPageNumber
  | SetCatalogNbPages
  | SetCatalogNbProducts
  | CreateAlertSuccess
  | ApplyFilter
  | TrackProductClick
  | TrackProductCrossSellClick
  | TrackProductFeedClick
  | TrackSeoLinksClick
  | SetMarketingFilter
  | SetDeal;
